import Dashboard from '@/views/dashboard/Dashboard.vue'

const dashboardRouter = (beforeEnter) => {
    return {
        beforeEnter: beforeEnter,
        name: 'Dashboard',
        path: '/dashboard',
        meta: {
            requiresAuth: true,
            isEmployee: true,
            breadcrumb: true,
            breadcrumbName: 'Dashboard',
            layout: 'default'
        },
        component: Dashboard
    }
}

export default dashboardRouter
